import React, { useState } from "react";
import axios from "axios";

// Import Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchData } from "../Hooks/useFetchData";

// Import Navbar
import { UserNavbar } from "../Components/UserNavbar";

// Import Iconos
import {
  FaEnvelope,
  FaPhone,
  FaKey,
  FaGift,
  FaStar,
  FaTimes,
  FaCamera,
} from "react-icons/fa";

import logo from "../Assets/Images/remesalogo.png";

function Profile() {
  //DataContext
  const { url, accessToken } = useDataContext();
  useAxiosInterceptors();

  //User data
  const { user } = useFetchData(accessToken.access_token);

  //Modal Change Password
  const [showModal, setShowModal] = useState(false);

  // Loading and messages
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Manejar cambio de foto de perfil
  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("use_profileImg", file);

      try {
        await axios.put(`${url}/Users/profileImg/${user.use_id}`, formData, {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (err) {
        console.error("Error al subir la imagen:", err);
        setErrorMsg(err.response.data.message || "Error al subir la imagen.");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      if (
        formData.newPassword === formData.confirmPassword &&
        formData.newPassword.length >= 6
      ) {
        setSuccessMsg("¡Contraseña actualizada correctamente!");
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        setErrorMsg("Las contraseñas no coinciden o son muy cortas.");
      }
    }, 2000);
  };

  return (
    <>
      <div className="profile-page">
        {errorMsg && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "2rem 2.5rem",
                borderRadius: "16px",
                boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
                textAlign: "center",
                minWidth: "300px",
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  color: "#ff9800",
                  marginBottom: "1rem",
                }}
              >
                ⚠️
              </div>
              <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
                ¡Advertencia!
              </div>
              <div>{errorMsg}</div>
              <button
                style={{
                  marginTop: "1.5rem",
                  padding: "0.5rem 1.5rem",
                  borderRadius: "8px",
                  border: "none",
                  background: "#ff9800",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => setErrorMsg("")}
              >
                Cerrar
              </button>
            </div>
          </div>
        )}
        <div className="profile-header">
          <div className="profile-avatar-wrapper">
            {user?.use_profileImg ? (
              <img
                src={`${url}/Users/profileImg/${user.use_profileImg}`}
                alt="Foto de perfil"
                className="profile-avatar"
              />
            ) : (
              <span
                className="skeleton-loader"
                style={{ width: 120, height: 120, borderRadius: "50%" }}
              />
            )}
            <div className="edit-overlay">
              <FaCamera />
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handlePhotoChange}
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
                zIndex: 2,
              }}
            />
          </div>
          <h2>
            {user ? (
              <>
                {user.use_name} {user.use_lastName}
              </>
            ) : (
              <span className="skeleton-loader" style={{ width: 120 }} />
            )}
          </h2>
          <span>
            {user ? (
              user.use_verif === "S" ? (
                "Usuario verificado"
              ) : (
                "Usuario no verificado"
              )
            ) : (
              <span className="skeleton-loader" style={{ width: 100 }} />
            )}
          </span>
        </div>

        <div className="profile-info">
          <div className="info-row">
            <span className="label">
              <FaEnvelope /> Correo
            </span>
            <span className="value">
              {user ? (
                user.use_email
              ) : (
                <span className="skeleton-loader" style={{ width: 140 }} />
              )}
            </span>
          </div>

          <div className="info-row">
            <span className="label">
              <FaPhone /> Teléfono
            </span>
            <span className="value">
              {user ? (
                user.use_phone
              ) : (
                <span className="skeleton-loader" style={{ width: 100 }} />
              )}
            </span>
          </div>

          <div className="info-row">
            <span className="label">
              <FaGift /> Código de referido
            </span>
            <span className="value">
              {user ? (
                user.use_referrerCode
              ) : (
                <span className="skeleton-loader" style={{ width: 80 }} />
              )}
            </span>
          </div>

          <div className="info-row">
            <span className="label">
              <FaStar /> Puntos acumulados
            </span>
            <span className="value">
              {user ? (
                user.use_loyaltyPoints
              ) : (
                <span className="skeleton-loader" style={{ width: 60 }} />
              )}
            </span>
          </div>

          <div className="info-row password-row">
            <button
              onClick={() => {
                setShowModal(true);
                setSuccessMsg("");
                setErrorMsg("");
                setFormData({
                  currentPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                });
              }}
            >
              <FaKey style={{ marginRight: "0.5rem" }} />
              Cambiar contraseña
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={() => setShowModal(false)}>
              <FaTimes />
            </button>
            <img src={logo} alt="logo" className="modal-logo" />

            {loading ? (
              <div className="spinner" />
            ) : successMsg ? (
              <div className="success-check">
                <div className="animated-check">
                  <svg viewBox="0 0 52 52">
                    <circle
                      className="check-circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="check-mark"
                      fill="none"
                      d="M14 27l7 7 16-16"
                    />
                  </svg>
                </div>
                <p className="success-text">{successMsg}</p>
                <div className="center-btn">
                  <button
                    className="submit-btn"
                    onClick={() => setShowModal(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            ) : (
              <>
                <h3>Cambiar contraseña</h3>
                <form onSubmit={handleSubmit}>
                  <input
                    className="minimal-input"
                    type="password"
                    name="currentPassword"
                    placeholder="Contraseña actual"
                    value={formData.currentPassword}
                    onChange={handleChange}
                    required
                  />
                  <input
                    className="minimal-input"
                    type="password"
                    name="newPassword"
                    placeholder="Nueva contraseña"
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                  />
                  <input
                    className="minimal-input"
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirmar nueva contraseña"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  <button className="submit-btn" type="submit">
                    Actualizar
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      <UserNavbar logOut={user?.use_email}/>
    </>
  );
}

export { Profile };
